import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from "react";
import { Grid } from "@mui/material";
import { alertService, setBackdrop, timeSince } from "common-frontend-components";
import { textColor } from "../../../assets/styles/colors";
import { postCardStyle } from "../../../assets/styles/styles";
import { PhotoUploader } from "../posts/Photos/PhotoUploader";
import { callCreateSitePhotoGroupAsync, callDeleteSitePhotoGroupAsync, callEditSitePhotoAsync } from "../../../apis/sitePhotos";
import { sitePhotoGroupStore } from "../../../stores/appConfig/sitePhotoGroupStore";
import { createSitePhotoImages } from "./CreateSitePhoto";
import { JsonInput } from "./JSONEditorReact";
import { GroupSelector } from "./SelectGroup";
export const EditSitePhoto = ({ sitePhoto, groups, onCancel, onSuccess, onUpdate, }) => {
    const [editGroups, setEditGroups] = useState(groups);
    const [edit, setEdit] = useState(sitePhoto);
    const [photos, setPhotos] = useState([]);
    const onEdit = async () => {
        setBackdrop(true);
        try {
            const response = await callEditSitePhotoAsync(edit.id, {
                params: edit.params,
            });
            onUpdate(response);
            const groupsToDelete = groups
                .filter(i => !editGroups.includes(i))
                .map(i => {
                const groupsByName = sitePhotoGroupStore.getMapByGroupName()[i] || [];
                const group = groupsByName.find(g => g.sitePhotoId === edit.id);
                return { groupsByName, groupName: i, group };
            })
                .filter(i => i.group !== undefined)
                .map(i => i.group?.id);
            await Promise.all(groupsToDelete
                .map(i => callDeleteSitePhotoGroupAsync(i)
                .then(() => sitePhotoGroupStore.setData(sitePhotoGroupStore.getData()
                .filter(a => a.id !== i)))));
            const groupsToCreate = editGroups
                .filter(i => !groups.includes(i));
            await Promise.all(groupsToCreate
                .map(group => callCreateSitePhotoGroupAsync({ group, sitePhotoId: edit.id })
                .then((a) => sitePhotoGroupStore.setData([a, ...sitePhotoGroupStore.getData()]))));
            // TODO: add support for photo deletion
            // const photosToDelete:PhotoResponse[] = photosStore.getPhotosById(post.id) || [];
            const photosToCreate = [];
            //
            // if (preview) {
            //   await Promise.all(photosToDelete
            //     .filter(i => i.phototype === 'preview')
            //     .map(photo => onDeletePhoto(photo))
            //   );
            //   photosToCreate.push({file: new File(
            //     [preview?.file as Blob],
            //     "preview.png",
            //     {type: "image/png", lastModified: Date.now()}
            //   ), index: '0', phototype: 'preview'});
            // }
            //
            // if (photos.length > 0) {
            //   await Promise.all(photosToDelete
            //     .filter(i => i.phototype !== 'preview')
            //     .map(photo => onDeletePhoto(photo))
            //   );
            photosToCreate.push(...photos.map((file) => ({ file, path: edit.path, CacheControl: edit.params?.CacheControl })));
            // }
            await createSitePhotoImages(photosToCreate);
            alertService.success('site photo updated!', { timeout: 4000 });
            onSuccess();
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            setBackdrop(false);
        }
    };
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", elevation: 3, sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsxs(Typography, { sx: { fontSize: '1.5rem', fontWeight: 600, paddingBottom: 1, color: textColor }, color: "text.secondary", gutterBottom: true, children: ["Edit: ", edit.path, _jsx(Box, { sx: { fontSize: '.85rem', fontWeight: 300, color: textColor + '55' }, children: timeSince(new Date(edit.created)) }, void 0)] }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsxs(Grid, { item: true, xs: 12, children: [_jsx(Typography, { sx: { fontSize: '1rem', paddingBottom: 0, color: textColor }, color: "text.secondary", gutterBottom: true, children: "Custom Parameters" }, void 0), _jsx(JsonInput, { boxProps: { sx: { width: '100%', height: 300 } }, onChange: (params) => setEdit({ ...edit, params }), value: edit.params }, void 0)] }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PhotoUploader, { onDrop: setPhotos, usePreviewFiles: () => photos, setPreviewFiles: setPhotos }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(GroupSelector, { value: editGroups, onChange: (_, newValue) => setEditGroups(newValue) }, void 0) }, void 0)] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsxs("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: [_jsx(Button, { size: "small", onClick: onCancel, children: "Cancel" }, void 0), _jsx(Button, { size: "small", onClick: onEdit, children: "Save" }, void 0)] }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=EditSitePhoto.js.map